import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getExportDashboardQuery($dashboardId:ID!,$type:String!){
    exportDashboard(dashboardId:$dashboardId,type:$type){
      filePath
      id
    }
  }
`